/**
 * Debug Badge - Sichtbarer Beweis welche UI-Version läuft
 * Nur in Development oder wenn VITE_UI_DEBUG=true
 */

import { useEffect, useState } from 'react';

const BUILD_INFO = {
  version: 'v3.0-portal',
  timestamp: new Date().toISOString().split('T')[0],
  env: import.meta.env.MODE,
};

export function DebugBadge() {
  const [isVisible, setIsVisible] = useState(false);
  const [buildTime] = useState(() => new Date().toLocaleTimeString('de-DE'));

  useEffect(() => {
    // Nur in Development ODER wenn VITE_UI_DEBUG=true
    const shouldShow = 
      import.meta.env.DEV || 
      import.meta.env.VITE_UI_DEBUG === 'true';
    
    setIsVisible(shouldShow);

    // Console Proof
    if (shouldShow) {
      console.info(
        '%c[PREMIUM V2] UI Active',
        'background: #009544; color: white; padding: 4px 8px; font-weight: bold; border-radius: 4px',
        {
          version: BUILD_INFO.version,
          timestamp: BUILD_INFO.timestamp,
          buildTime,
          mode: BUILD_INFO.env,
        }
      );
    }
  }, [buildTime]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-20 right-4 z-[9999] pointer-events-none">
      <div className="bg-gradient-to-r from-emerald-500 to-green-600 text-white px-3 py-1.5 rounded-lg shadow-lg text-xs font-mono flex items-center gap-2 border border-white/20">
        <span className="w-2 h-2 bg-green-300 rounded-full animate-pulse" />
        <div className="flex flex-col leading-tight">
          <span className="font-bold">UI: {BUILD_INFO.version}</span>
          <span className="opacity-80 text-[10px]">
            {BUILD_INFO.timestamp} • {buildTime}
          </span>
        </div>
      </div>
    </div>
  );
}
